import React, { FC, useEffect, useState } from "react";
import styles from "./TableHead.module.sass";
import cn from "classnames";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { ChangeChooseAll, ChangeChooseAllGlobal } from "toolkit/steps/stepSix/stepSix.slice";

const tableTitles = ["№", "Оставшееся время", "Код", "Наименование", "Тип объекта", "Сфера деятельности объекта"];

export const TableHead: FC = () => {
	const { batchesMode, formationMode, allChecked } = useAppSelector((state) => state.stepSix);
	const [checkbox, setCheckbox] = useState<boolean>(false);
	const dispatch = useAppDispatch();

	useEffect(() => {
		if (!allChecked) setCheckbox(false);
		else setCheckbox(true);
	}, [allChecked]);

	const checkboxHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		setCheckbox(e.target.checked);
		dispatch(ChangeChooseAll(e.target.checked));
		dispatch(ChangeChooseAllGlobal(e.target.checked));
	};

	return (
		<table className={styles["table-head"]}>
			<thead className={styles.head}>
				<tr className={styles.row}>
					{!formationMode && (
						<th className={cn(styles.cell, batchesMode ? styles["cell-sign-batches"] : styles["cell-sign"])}></th>
					)}
					{formationMode && (
						<th className={styles.cell}>
							<label className={styles.label} htmlFor="allChecked">
								<input
									id="allChecked"
									checked={checkbox}
									onChange={checkboxHandler}
									type="checkbox"
									className={styles.checkbox}
								/>
							</label>
						</th>
					)}
					{tableTitles.map(
						(title, i) =>
							((batchesMode && title !== "Оставшееся время") || !batchesMode) && (
								<th key={i} className={cn(styles.cell, batchesMode ? styles.batches : styles.default)}>
									{title}
								</th>
							),
					)}
				</tr>
			</thead>
		</table>
	);
};
